import { useEffect, useState, useRef } from "react";
import getAllBranches from "../../apis/getAllBranches";
import apiCall from "../../helpers/apifactory";
import MapPopup from "./MapPopup";
import getCities from "../../apis/getCities";
import getBranchesByCities from "../../apis/getBranchesByCities";
import GoogleMap from "./GoogleMap";

const Map = ({ city }) => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false
  );

  const searchRef = useRef();
  const scrollRef = useRef(null);
  const [mapHover, setMapHover] = useState(false);
  const [branches, setBranches] = useState([]);
  const [cities, setCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [offices, setOffices] = useState([]);
  const [popupCity, setPopupCity] = useState(null);
  const [zoom, setZoom] = useState(18);

  const [center, setCenter] = useState({ lat: 24.89496195, lng: 67.15677305 });

  // useEffect(() => {
  //   const fun = async () => {
  //     const result = await apiCall.allbranchesApi();
  //     if (result && result.data["IsSuccess"]) {
  //       setBranches(result.data["Data"]);
  //     }
  //     const citiesResult = await apiCall.citiesApi();
  //     if (citiesResult && citiesResult.data["IsSuccess"]) {
  //       setCities(citiesResult.data["Data"]);
  //       setFilteredCities(citiesResult.data["Data"]);
  //     }

  //     navigator.geolocation.getCurrentPosition(function (position) {
  //       setCenter({
  //         lat: position.coords.latitude,
  //         lng: position.coords.longitude,
  //       });
  //     });
  //   };
  //   fun();
  // }, []);

  useEffect(() => {
    const funcall = async () => {
      if (city !== null) {
        await getBranches(city);
        window.scroll({
          top: 200,
          left: 0,
          behavior: "smooth",
        });
        setZoom(12);
        searchRef.current.value = city;
      }
    };
    funcall();
  }, [city]);

  const handleFilteredCites = (e) => {
    let str = e.target.value;
    str = str.toLowerCase();

    const newcities = cities.filter(
      (city) => city.City.toLowerCase().includes(str) || e.target.value === ""
    );
    setFilteredCities(newcities);
  };

  const getBranches = async (city) => {
    if (city !== "") {
      // const resultsOld = await apiCall.branchesbycityApi(city);
      const results = await apiCall.getBranchesByCity(city);
      let index = (results?.data?.responseData?.grn_detail?.length / 2)
        .toString()
        .split(".")[0];
      if (results.data?.responseData?.message == "SUCCESS") {
        console.log("00000");
        setBranches(results?.data?.responseData?.grn_detail);
        setOffices(results?.data?.responseData?.grn_detail);
        setCenter({
          // lat: +results.data["Data"][0]["lat"],
          lat: +results?.data?.responseData?.grn_detail[index]?.lat,
          // lng: +results.data["Data"][0]["log"],
          lng: +results?.data?.responseData?.grn_detail[index]?.log,
        });
        setZoom(12);
      }
    }
  };

  const handleMarker = (id) => {
    const office = branches.filter((office) => office.exp_id === id);
    setZoom(18);
    setPopupCity(office[0]);
    setMapHover(true);
  };

  const handleCurrent = () => {
    navigator?.geolocation?.getCurrentPosition((position) => {
      setCenter({
        lat: position?.coords?.latitude,
        lng: position?.coords?.longitude,
      });
    });
  };

  return (
    <div className="mx-auto mt-12 shadow-my flex flex-col md:flex-row lg:w-[62rem]">
      <div className="w-[100%] md:w-[20rem]">
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className="bg-[#f7f7f7] p-4 m-3 rounded-sm relative"
        >
          <h2 className="font-semibold text-xl pb-3">Search</h2>
          <div className="relative z-0 mb-6 w-full group">
            <input
              type="text"
              name="cities"
              id="cities"
              list="cities"
              ref={searchRef}
              onChange={handleFilteredCites}
              className="block py-2.5 w-full text-sm bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-red-600 peer"
              placeholder=" "
              required
            />
            <label
              htmlFor="cities"
              className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-red-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Enter Your City
            </label>
          </div>
          <div className="absolute bottom-[-1rem] right-3 flex gap-3">
            <div
              className="bg-[#dadada] rounded-full w-10 h-10 p-2 flex justify-center items-center"
              onClick={handleCurrent}
            >
              <img src="/location.svg" alt="" />
            </div>
            <button
              type="submit"
              className="bg-[#f21e26] rounded-full w-10 h-10 p-3 flex justify-center items-center"
              onClick={() => getBranches(searchRef.current.value)}
            >
              <img src="/search.svg" alt="" />
            </button>
          </div>
        </form>

        <h2 className="text-[#f21e26] font-semibold text-lg p-4">
          Search Result
        </h2>
        <div className="min-h-[5rem] max-h-20rem h-auto md:h-[20rem] overflow-y-scroll">
          {offices.map((office) => (
            <div
              key={office.exp_id}
              className="border-t px-4 py-4 flex flex-col gap-1 cursor-pointer"
              onClick={() => {
                setMapHover(true);
                setPopupCity(office);
                setCenter({ lat: +office.lat, lng: +office.log });
                setZoom(18);
                console.log("Latitude:", +office.lat);
                console.log("Longitude:", +office.log);
                if (window?.screen?.width < 768)
                  scrollRef?.current.scrollIntoView();
              }}
            >
              <h2 className="font-semibold text-sm">{office.name}</h2>
              <p className="text-xs">City: {office.city}</p>
              <p className="text-xs">Address: {office.address}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="relative flex-1">
        <div className="h-[34rem]" ref={scrollRef}>
          <GoogleMap
            // googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyA60gAFM1MOpyBF30dymn-_F3sOanHcGGs"
            // loadingElement={<div style={{ height: `100%` }} />}
            // containerElement={<div style={{ height: `100%` }} />}
            // mapElement={<div style={{ height: `100%` }} />}
            branches={branches}
            handleMarker={handleMarker}
            center={center}
            zoom={zoom}
          />
        </div>
        {mapHover && (
          <>
            <div className="absolute top-0 lg:w-full w-[30rem] h-full bg-black opacity-30"></div>
            <MapPopup onClose={() => setMapHover(false)} office={popupCity} />
          </>
        )}
      </div>
    </div>
  );
};

export default Map;
